import React from "react";

import hero_Img from "../assets/home_banner.png";
import hardhat_Img from "../assets/hardhat_Img.png"; //
import FrontendLayout from "../components/FrontendLayout";

import standardised_light_icon from "../assets/cards_icons/standardised_light.svg";
import standardised_dark_icon from "../assets/cards_icons/standardised_dark.svg";

import tbridge_light_icon from "../assets/cards_icons/bridge_code_light.svg";
import tbridge_dark_icon from "../assets/cards_icons/bridge_code_dark.svg";

import technical_light_icon from "../assets/cards_icons/technical_light.svg";
import technical_dark_icon from "../assets/cards_icons/technical_dark.svg";

import material_light_icon from "../assets/cards_icons/material_testing_light.svg";
import material_dark_icon from "../assets/cards_icons/material_testing_dark.svg";

import project_light_icon from "../assets/cards_icons/project_implementation_light.svg";
import project_dark_icon from "../assets/cards_icons/project_implementation_dark.svg";

import tors_light_icon from "../assets/cards_icons/model_tors_light.svg";
import tors_dark_icon from "../assets/cards_icons/model_tors_dark.svg";

import standardised_Img from "../assets/info_cards/standarddised_project_Img.svg";
import bridge_Img from "../assets/info_cards/bridge_Img.svg";
import technical_Img from "../assets/info_cards/tcehncal_appraisal_Img.svg";
import material_Img from "../assets/info_cards/material_testing_Img.svg";
import moderlTors_Img from "../assets/info_cards/model_tors_Img.svg";
import project_policy_Img from "../assets/info_cards/project_policy_Img.svg";

import easy_normal from "../assets/benefits_icons/easy.svg";
import easy_white from "../assets/benefits_icons/easy-white.svg";

import faq_help_normal from "../assets/benefits_icons/help-102.svg";
import faq_help_white from "../assets/benefits_icons/help-white.svg";

import safe_normal from "../assets/benefits_icons/safe-25.svg";
import safe_white from "../assets/benefits_icons/safe-white.svg";

import easyToUse_normal from "../assets/benefits_icons/easy-to-use-1.svg";
import easyToUse_white from "../assets/benefits_icons/easy-to-use-white.svg";

import device_normal from "../assets/benefits_icons/029-devices.svg";
import device_white from "../assets/benefits_icons/devices-white.svg";

import efficeint_Img_normal from "../assets/benefits_icons/give-the-thumbs-up-8.svg";
import efficeint_Img_white from "../assets/benefits_icons/give-the-thumbs-up-white.svg";

import arrow_icon from "../assets/info_cards/arrow_icon.svg";
import Card from "../components/Card";
import InfoCard from "../components/InfoCard";
import HomeHeadings from "../components/HomeHeadings";
import BenefitCard from "../components/BenefitCard";
import { Accordion, AccordionItems } from "../components/Accordion";
import Input from "../components/Input";
import First_Section_image from "../assets/First_Section_image.png";
import { useNavigate } from "react-router-dom";

export default function Home() {
  const navigate = useNavigate();

  return (
    <FrontendLayout>
      <div className="flex justify-center">
        <div className="absolute flex-col w-[456px] mr-8 mt-40 bg-green-900 text-center bg-opacity-55 py-3">
          <span className="text-4xl font-poppins text-center py-10 text-white  select-none">
          Khyber Pakhtunkhwa PIM Portal
          </span>
        </div>
        <img
          className="h-[70vh] w-screen object-cover pointer-events-none select-none"
          src={hero_Img}
          alt="hero_section "
        />
      </div>

      <div className="flex items-center justify-center px-5 gap-5 -translate-y-24 z-0 ">
        <Card
          label="Standardised Modular Designs"
          icon={standardised_dark_icon}
          lightIcon={standardised_light_icon}
          navigate={() => navigate("/download-doc/Standardised_Modular_Designs")}
        />
        <Card
          label="Bridge Code"
          icon={tbridge_dark_icon}
          lightIcon={tbridge_light_icon}
          navigate={() => navigate("/download-doc/Bridge_Code")}
        />
        <Card
          label="Technical Appraisal Checklist"
          icon={technical_dark_icon}
          lightIcon={technical_light_icon}
          navigate={() => navigate("/download-doc/Technical_Appresial")}
        />
        <Card
          label="Materials and Qualification Testing"
          icon={material_dark_icon}
          lightIcon={material_light_icon}
          navigate={() => navigate("/download-doc/Material_Testing")}
        />
        <Card
          label="CRI Handbook"
          icon={project_dark_icon}
          lightIcon={project_light_icon}
          navigate={() => navigate("/download-doc/CRI_Guidelines_Handbook")}
        />
        <Card
          label="Project Implementation Policy"
          icon={tors_dark_icon}
          lightIcon={tors_light_icon}
          navigate={() => navigate("/download-doc/Project_Implementation")}
        />
        <Card
          label="Model TORs"
          icon={tors_dark_icon}
          lightIcon={tors_light_icon}
          navigate={() => navigate("/download-doc/Mode_Tors")}
        />
      </div>

      <div id="about-us" className="flex flex-row gap-10 p-10  justify-center">
        <div className="font-poppins text-primary w-1/2 ">
          <p className="text-lg font-normal  font-roboto py-5  leading-8 ">
          The Khyber Pakhtunkwa (KP) Public Investment Management (PIM) portal is a significant step towards enhancing the efficiency and effectiveness of public investment in infrastructure. On this portal, you will find a suite of seven essential tools designed to optimize public investment management. These tools are part of the KP government’s ongoing efforts to streamline processes, improve transparency, and foster sustainable development. Explore these tools and avail resources for efficient and climate-resilient public infrastructure investment.
          </p>
        </div>
        <div className="flex flex-row justify-center items-center w-1/3 select-none ">
          <img
            src={First_Section_image}
            alt="stop sign construction"
            className="w-96"
          />
        </div>
      </div>

      <div className="flex flex-col gap-10 p-10 px-28 select-none  ">
        <InfoCard
          ImageSource={standardised_Img}
          heading="Standardized Modular Designs"
          text="Generate entire PC-1 documents for your projects using our comprehensive forms. These standardized modular designs ensure efficiency and consistency in project planning."
          linkAddress="/download-doc/Standardised_Modular_Designs#"
        />
        <InfoCard
          ImageSource={bridge_Img}
          heading="Bridge Code"
          LTR
          text="Access the latest standards for robust bridge construction. Stay informed on regulations, guidelines, and specifications to enhance the structural integrity of your projects."
          linkAddress="/download-doc/Bridge_Code"
        />
        <InfoCard
          ImageSource={technical_Img}
          heading="Technical Appraisal Checklist"
          text="Optimize project assessments with our detailed checklists. Ensure that your projects meet the highest standards by systematically evaluating key technical aspects at every stage."
          linkAddress="/download-doc/Technical_Appresial"
        />
        <div id="policy-sec"></div>
        <InfoCard
          ImageSource={project_policy_Img}
          heading="Project Implementation Policy"
          LTR
          text="Gain insights into effective project implementation with our comprehensive policy guidelines. Navigate the intricacies of project execution and management for successful outcomes."
          linkAddress="/download-doc/Project_Implementation"
        />

        <InfoCard
          ImageSource={material_Img}
          heading="Materials and Qualification Testing"
          text="Stay informed on materials testing and qualification procedures. Access guidelines and resources to ensure that the materials used in your projects meet stringent quality standards."
          linkAddress="/download-doc/Material_Testing"
        />
        
        <InfoCard
          ImageSource={moderlTors_Img}
          heading="Model TORs"
          LTR
          text="Effortlessly navigate project planning with our model TORs. Tailored to meet the unique requirements of the C&W Department, these templates serve as a foundation for clear project scopes and objectives."
          linkAddress="/download-doc/Mode_Tors"
        />
        <InfoCard
          ImageSource={material_Img}
          heading="CRI Handbook"
          text="Consult detailed guidelines on designing and building climate resilient infrastructure (CRI). This handbook ensures that your project designs incorporate essential aspects of climate resilience."
          linkAddress="/download-doc/CRI_Guidelines_Handbook"
        />
      </div>

      {/* <HomeHeadings>
        <p className=" py-2 font-medium ">Benefits of the Portal </p>
      </HomeHeadings> */}

      {/* <div className="flex flex-col gap-5 items-center">
        <div className="flex flex-row gap-5  ">
          <BenefitCard
            NormalImg={easy_normal}
            whiteImg={easy_white}
            label="Easily Accessible"
            text="You can access the repository from anywhere in the country."
          />
          <BenefitCard
            NormalImg={safe_normal}
            whiteImg={safe_white}
            label="Safe & Secure"
            text="Your files are secured with advance level SSL encryption."
          />
          <BenefitCard
            NormalImg={faq_help_normal}
            whiteImg={faq_help_white}
            label="FAQs & Help"
            text="To get help you can contact us by clicking here or read our FAQs."
          />
        </div>
        <div className="flex flex-row items-center gap-5 py-5">
          <BenefitCard
            NormalImg={device_normal}
            whiteImg={device_white}
            label="Device Compatible"
            text="The repo can be accessed through internet using any mobile or computer."
          />
          <BenefitCard
            NormalImg={easyToUse_normal}
            whiteImg={easyToUse_white}
            label="Easy to Use"
            text="Just input basic engineering information about project and get final drawing and cost estimates."
          />
          <BenefitCard
            NormalImg={efficeint_Img_normal}
            whiteImg={efficeint_Img_white}
            label="Efficient & Innovative"
            text="Streamlining & automating technical part of PC-I has made the entire process very simple & cost effective."
          />
        </div>
      </div> */}

      {/* <HomeHeadings id={"faq-sec"}>FAQ's</HomeHeadings> */}
      {/* <div className="w-1/2 px-36 leading-6 text-base py-5">
        Whether you’re a seasoned user or just getting started, these answers
        are tailored to enrich your understanding of the tools and ensure a
        seamless experience. Explore below to find quick solutions, learn best
        practices, and enhance your proficiency in utilizing the diverse
        features available at your fingertips.
      </div>

      <div className=" flex justify-center w-full">
        <div className="w-4/5">
          <Accordion>
            <AccordionItems
              label={
                "What is a PIM Tool, and how does it benefit the Communication and Works Department of KP?"
              }
            >
              <span>
                A Product Information Management (PIM) Tool is a centralized
                platform that helps manage and distribute product information.
                For KP's Communication and Works Department, the PIM Tool
                streamlines project planning, offers standardized modular
                designs, and provides essential documents for efficient and
                consistent project implementation.{" "}
              </span>{" "}
            </AccordionItems>
            <AccordionItems
              label={
                "What types of documents are available in the Standardized Modular Designs section?"
              }
            >
              <span>
                The Standardized Modular Designs section provides comprehensive
                forms that generate entire PC-1 documents for projects. These
                forms cover essential aspects of project planning and execution.
              </span>{" "}
            </AccordionItems>
            <AccordionItems
              label={"How can I download documents from the PIM Tools portal?"}
            >
              <span>
                To download documents, navigate to the specific tool or
                component, and look for the download button or link associated
                with the document you need. Click on it to initiate the
                download.{" "}
              </span>{" "}
            </AccordionItems>
            <AccordionItems
              label={
                "Are there any guidelines for using the Technical Appraisal Checklists?"
              }
            >
              <span>
                Yes, detailed guidelines on how to use the Technical Appraisal
                Checklists are available within the tool. Each checklist is
                accompanied by instructions to ensure thorough project
                assessments.
              </span>{" "}
            </AccordionItems>
            <AccordionItems
              label={"Can I submit feedback or suggestions for improvement?"}
            >
              <span>
                Absolutely! We value user feedback. You can submit your
                suggestions or report issues through the "Feedback" section on
                the portal. Your input helps us enhance the functionality and
                usefulness of the PIM Tools.
              </span>{" "}
            </AccordionItems>
            <AccordionItems
              label={"Is there a user guide available for the PIM Tools?"}
            >
              <span>
                Yes, there is a dedicated section providing user guides and
                tutorials. This section offers step-by-step instructions on how
                to effectively utilize the features of the PIM Tools.
              </span>
            </AccordionItems>
            <AccordionItems
              label={
                "How can I contact the C&W Department for further assistance?"
              }
            >
              <span>
                For inquiries and assistance, please refer to the contact
                information provided in the footer of the portal. You can reach
                out to C&W Department personnel via phone or email for any
                additional support or information.
              </span>
            </AccordionItems>
          </Accordion>
        </div>
      </div> */}

      <div className="flex flex-col gap-5 bg-primary bg-cover w-full h-full bg-pattern-bg px-2 text-white py-10 border-b border-gray-500">
        <div className="flex flex-row gap-10  p-10 justify-center">
          <p id="feed-back-form" className="w-1/4 text-5xl font-poppins ">
            Feedback
          </p>
          <p className="w-7/12 text-base font-roboto">
            We are dedicated to refining and evolving our tools based on your
            valuable insights. Your feedback is crucial in shaping the future of
            the PIM portal. Whether you have suggestions for improvement,
            want to share your experiences, or have encountered any issues, we
            want to hear from you.
          </p>
        </div>

        <div className="flex flex-col">
          <div className="flex flex-row gap-10  p-10 justify-center ">
            <div className=" flex flex-col gap-1 w-1/2  ">
              <label className="text-white font-poppins">Name</label>
              <Input
                type="text"
                required
                name="username"
                placeholder="Enter Name"
                className="h-10 w-50 font-poppins bg-primary py-2 text-white"
                focusBorder="focus:border-secondary"
              />
            </div>
            <div className=" flex flex-col gap-1 w-1/2  ">
              <label className="text-white font-poppins">Email</label>
              <Input
                type="email"
                required
                name="useremail"
                placeholder="Enter Email"
                className="h-10 w-50 font-poppins bg-primary py-2 "
                focusBorder="focus:border-secondary"
              />
            </div>
          </div>

          <div className="flex flex-row gap-10  p-10 justify-center">
            <div className=" flex flex-col gap-1 w-full">
              <label className="text-white font-poppins">Message</label>
              <Input
                type="text"
                required
                name="message"
                placeholder="Enter Message"
                className="h-10 w-50 font-poppins bg-primary py-2 text-white"
                focusBorder="focus:border-secondary"
              />
            </div>
          </div>
          <button className=" flex flex-row items-center w-fit px-10 py-3 rounded-lg text-secondary gap-2 transition hover:text-green-400 hover:translate-x-2 duration-300">
            <span> Submit</span>
            <img src={arrow_icon} alt="arrow_icon" className="w-8 " />
          </button>
        </div>
      </div>
    </FrontendLayout>
  );
}
